import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'
import {
  buildMissingFieldsMessage,
  IncompleteRevRecLineItem
} from './buildMissingFieldsMessage'

// One toast id for both flows, so re-submitting replaces the warning in place
// rather than stacking a fresh copy each time.
const NOTIFICATION_ID = 'credit-note-revrec-warning'

/**
 * Warns that line items are missing the rev-rec details needed to issue. A
 * single offending item gets an Edit button straight to it; several can't, so
 * the toast only says that some are incomplete.
 */
export const useCreditNoteRevRecWarning = () => {
  const { displayNotification } = useNotifications()

  return useCallback(
    ({
      incompleteLineItems,
      onEdit,
      useRevRec = false
    }: {
      incompleteLineItems: IncompleteRevRecLineItem[]
      onEdit: (lineItemId: string) => void
      useRevRec?: boolean
    }) => {
      const singleItem =
        incompleteLineItems.length === 1 ? incompleteLineItems.at(0) : undefined

      displayNotification(
        singleItem
          ? `"${singleItem.title}" has missing details`
          : 'Some line items have missing details',
        {
          type: 'error',
          id: NOTIFICATION_ID,
          'data-testid': 'creditNote.revRecWarning',
          ...(useRevRec
            ? { description: buildMissingFieldsMessage(incompleteLineItems) }
            : {}),
          ...(singleItem
            ? { viewLabel: 'Edit', onClickView: () => onEdit(singleItem.id) }
            : {})
        }
      )
    },
    [displayNotification]
  )
}
